import {Link, Navigate, useNavigate} from "react-router-dom";
import React, {createContext, useContext, useEffect, useState} from "react";
import { HeaderLogo } from "../components/headerLogoComponent";
import { NavigationBar } from "../components/NavigationBar";
import '../../styles/mainpage.css';
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import HelperService from "../Services/Bll/HelperService";
import AppService from "../Services/Bll/AppService";
import { FilterPanel } from "../components/FilterPanelComponent";

import { PieChartCustom } from "../components/charts/PieChartCustom"
import { BarChartCustom } from "../components/charts/BarChartCustom"
import { BasicIndicator } from "../components/charts/BasicIndicator"
import {mockDataBar1, mockDataBar2, mockDataBarRes, mockDataBarDest} from "../data/mockPieDataBar";
import FilterPanelProvider from "../Provider/FilterPanelProvider";
import {motion as m} from "framer-motion"
import {LineChartCustom} from "../components/charts/LineChartCustom";
import {mockDataLine} from "../data/mockDataLine";
import {ViewContext} from "../Context/ViewContext";
import KpiService from "../Services/Bll/KpiService";

import {createTheme, useMediaQuery} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import LoaderComponent from "../components/LoaderComponent";

export default function CADetPage() {
  const {loader, showLoader, hideLoader} = useContext(ViewContext);
  const service = new AppService();

  const [kpi, setKpi] = useState(null);
  const navigate = useNavigate()
  const logged = HelperService.isLogged()
  const [loadingPage, setLoadingPage] = useState(null);
  const kpiService = new KpiService();

    const getGraphTitle = (dateRef, isGraph1) => {
        const titles = {
            depart: isGraph1 ? "CA par mois de départ" : "CA par mois de création",
            creation: isGraph1 ? "CA par mois de création" : "CA par mois de départ"
        };
        return titles[dateRef];
    };


    const theme = createTheme({
      breakpoints: {
          values: {
              xs: 0,
              sm: 600,
              md: 960,
              lg: 1280,
              xl: 1920,
          },
      },
  });
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    const fetchParams = {navigate, logged, showLoader, hideLoader, setKpi, isMobile};
    kpiService.fetchData(fetchParams)
  }, [])


  const handleKpiUpdate = (newsKpi) => {
    kpiService.handleKpiUpdate(newsKpi, setKpi)
  };

    const handleLoadingPage = (loading) => {
        setLoadingPage(loading);
    }

const labels = {label: kpi?.label, labelSecond: kpi?.labelSecond};


  const viewsItem = localStorage.getItem('backclick')
  var directionAnimation = '';
  var nameclass = '';
  if (viewsItem == 1) {
    directionAnimation = '-100vw'
    nameclass = "reverseAnim"
  } else {
    directionAnimation = '100vw'
    nameclass = ""
  }

  if (loader) return null;

  return (
    <>
        <NavigationBar />
        <FilterPanelProvider>
                {isMobile ? (
                    <Accordion className="h-auto" sx={{backgroundColor:'#b57ee3', borderRadius: '0 !important'}}>
                        <AccordionSummary
                            sx={{color:'white'}}
                            expandIcon={<ArrowDropDownIcon/>}
                        >
                            <span style={{fontSize:'12px', fontWeight:'bold'}}>Filtre</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FilterPanel onKpiUpdate={handleKpiUpdate} isMobile={isMobile} onLoadingPage={handleLoadingPage}/>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <FilterPanel onKpiUpdate={handleKpiUpdate} onLoadingPage={handleLoadingPage}/>
                )}
            </FilterPanelProvider>
            <LoaderComponent loadingPage={loadingPage}/>
            {!loadingPage && (
        <div className="indicContainer container">
                {kpi?.graph1 &&
                    <LineChartCustom data={kpi?.graph1 ? kpi?.graph1 : []}
                                     dataBis={kpi?.graph1Second ? kpi?.graph1Second : []}
                                     title={getGraphTitle(kpi?.dateRef, true)} labels={labels}/>}
                {kpi?.graph2 &&
                    <LineChartCustom data={kpi?.graph2} dataBis={kpi?.graph2Second ? kpi?.graph2Second : []}
                                     title={getGraphTitle(kpi?.dateRef)} labels={labels}/> }
                {kpi?.histo4 &&
                    <BarChartCustom data={kpi.histo4} dataBis={kpi.histo4Second} title="CA par destination" groupMode="grouped" keysArray={['N','N-1','objectif']} width="98%" height="325" left="100" fontSizeX={"9px"} labels={labels}/>}
                {kpi?.histo1 &&
                    <BarChartCustom data={kpi.histo1} dataBis={kpi.histo1Second} title="CA par commercial" groupMode="grouped"
                                    keysArray={['N', 'N-1', 'objectif']} colors="pastel2" width="98%" height="325" left="100" fontSizeX={"9px"} labels={labels}/>}
                {kpi?.histo2 &&
                    <BarChartCustom data={kpi.histo2} dataBis={kpi.histo2Second} title="CA par agent de réservation"
                                        groupMode="grouped" keysArray={['N', 'N-1', 'objectif']} width="98%" height="325" left="100" fontSizeX={"9px"} labels={labels}/>}
                {kpi?.histo3 &&
                    <BarChartCustom data={kpi.histo3} dataBis={kpi.histo3Second} title="CA par réseau" groupMode="grouped" keysArray={['N','N-1','objectif']} width="98%" height="325" left="100" fontSizeX={"9px"} labels={labels}/>}
        </div>)}
    </>
    );
}









